import { Get } from ".././MyHelpers";
import {Resource} from "./Resource";
export class JSONResource extends Resource
{
	get Name(): string {
		return this.name;
	}
	get Type(): string {
		return "json";
	}
	
	public json: any = {};

	public constructor(path: string, name: string = null, required: boolean = true) {
		super(path, name, required);
	}

	public Load(preventCache: boolean = false): void {
		Get.Text(
			this.path,
			(success: boolean, status: number, response: string) => {
				if (success) {
					try
					{
						this.json = JSON.parse(response);
						this.Loaded();
					}
					catch (ex)
					{
						this.LoadError();
					}
				}
				else {
					this.LoadError();
				}
		});
	}

	public override Reload(preventCache: boolean = false): void {
		this.loaded = false;
		this.processed = false;
		this.Load(preventCache);
	}
}